module.exports = __webpack_public_path__ + "static/media/happy_aarjav.0596dadc.png";